
import { NgModule } from '@angular/core';

import { FinancialBudgetEditProvider } from './financial-budget-edit.provider';
import { FinancialBudgetListProvider } from './financial-budget-list.provider';

export * from './financial-budget-edit.provider';
export * from './financial-budget-list.provider';

export {
  FinancialBudgetListProvider,
  FinancialBudgetEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    FinancialBudgetEditProvider,
    FinancialBudgetListProvider
  ]
})
export class FinancialBudgetBackendModule { }
